import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=d2ff6b40&"
import script from "./header-menu.vue?vue&type=script&lang=js&"
export * from "./header-menu.vue?vue&type=script&lang=js&"
import style0 from "./header-menu.vue?vue&type=style&index=0&id=d2ff6b40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports